export default {
  jp: {
    title: {
      account: 'アカウント申請',
      freelance: 'フリーランス申請',
      localMedia: 'ローカル媒体申請'
    },
    label: {
      id: 'ID',
      name: '氏名',
      group: '所属',
      company: '会社',
      branch: '支社・支局または媒体',
      postNo: '郵便番号',
      prefCd: '都道府県',
      addr1: '市区町村',
      addr2: '番地',
      addr3: 'ビル名',
      busho: '部署',
      telNo: '電話番号',
      remarks: '備考',
      services: '利用希望サービス',
      recommendationCompanyName: '推薦社名',
      recommendationMediaName: '推薦媒体名',
      mediaContents: '媒体内容',
      mediaIssueDetail: '媒体発行詳細',
      recommendationResponsibleName: '推薦責任者名',
      recommendationResponsibleMailAddress: '推薦責任者メールアドレス',
      recommendationReason: '推薦理由',
      trackRecord: '取材活動実績',
      mediaCoverageArea: '媒体カバーエリア',
      groupResponsibleName: 'グループ責任者名',
      userName: '利用者名',
      localMediaManagementClub: 'ローカル媒体管理クラブ',
      other: 'その他'
    },
    ph: {
      id: 'メールアドレスを入力してください',
      name: '氏名を入力してください',
      groupSmall: '選択してください',
      companyId: '選択してください',
      companyName: '「その他」を選択した場合に##COMPANY_LABEL##名を入力してください',
      companyNameKana: '「その他」を選択した場合に##COMPANY_LABEL##名（カナ）を入力してください',
      branch: '##BRANCH_LABEL##がある場合は選択してください',
      branchName: '「その他」を選択した場合に##BRANCH_LABEL##名を入力してください',
      branchNameKana: '「その他」を選択した場合に##BRANCH_LABEL##名（カナ）を入力してください',
      postNo: '郵便番号を入力してください',
      prefCd: '選択してください',
      addr1: '市区町村を入力してください',
      addr2: '番地を入力してください',
      addr3: 'ビル名を入力してください',
      busho: '部署を入力してください',
      telNo: '電話番号を入力してください',
      remarks: 'アカウントの申請目的をご記入ください。\n\n※記者・カメラマンの方は、ご自身が主に「ペン」または「フォト」いずれに当たるかをご記入ください。',
      recommendationCompanyName: '推薦社名を入力してください。',
      recommendationMediaName: '推薦媒体名を入力してください。',
      mediaContents: '媒体内容をご記入ください。',
      mediaIssueDetail: '部数や発行頻度をご記入ください。',
      recommendationResponsibleName: '推薦責任者名を入力してください。',
      recommendationResponsibleMailAddress: '推薦責任者メールアドレスを入力してください。',
      recommendationReason: '推薦理由をご記入ください。',
      trackRecord: 'これまでの取材活動の実績（露出媒体、URL等）をご記入ください。',
      mediaCoverageArea: '媒体カバーエリアをご記入ください。\n※Webの場合は会社所在地をご記入ください。',
      groupResponsibleName: 'グループ責任者名を入力してください。',
      userName: '利用者全員の氏名をご記入ください。',
      localMediaManagementClub: '選択してください',
      other: 'その他補足事項等あればご記入ください。'
    },
    error: {
      id: {
        required: 'IDは入力必須項目です。',
        maxLength: 'IDは100文字以内で入力してください。',
        invalid: 'IDの書式に誤りがあります。'
      },
      name: {
        required: '氏名は入力必須項目です。',
        maxLength: '氏名は50文字以内で入力してください。'
      },
      groupLargeId: {
        required: '所属（大分類）は入力必須項目です。',
        invalid: '所属（大分類）の入力内容に不備があります。'
      },
      groupSmallId: {
        required: '所属（小分類）は入力必須項目です。',
        invalid: '所属（小分類）の入力内容に不備があります。'
      },
      companyId: {
        required: '##COMPANY_LABEL##は入力必須項目です。',
        invalid: '##COMPANY_LABEL##の入力内容に不備があります。'
      },
      companyName: {
        required: '##COMPANY_LABEL##名は入力必須項目です。',
        maxLength: '##COMPANY_LABEL##名は100文字以内で入力してください。'
      },
      companyNameKana: {
        required: '##COMPANY_LABEL##名（カナ）は入力必須項目です。',
        maxLength: '##COMPANY_LABEL##名（カナ）は100文字以内で入力してください。',
        invalid: '##COMPANY_LABEL##名（カナ）は全角カナ、・、－で入力してください。'
      },
      branchId: {
        required: '##BRANCH_LABEL##は入力必須項目です。',
        invalid: '##BRANCH_LABEL##の入力内容に不備があります。'
      },
      branchName: {
        required: '##BRANCH_LABEL##名は入力必須項目です。',
        maxLength: '##BRANCH_LABEL##名は100文字以内で入力してください。'
      },
      branchNameKana: {
        required: '##BRANCH_LABEL##名（カナ）は入力必須項目です。',
        maxLength: '##BRANCH_LABEL##名（カナ）は100文字以内で入力してください。',
        invalid: '##BRANCH_LABEL##名（カナ）は全角カナ、・、－で入力してください。'
      },
      postNo: {
        required: '郵便番号は入力必須項目です。',
        maxLength: '郵便番号は20文字以内で入力してください。'
      },
      prefCd: {
        required: '都道府県は入力必須項目です。',
        maxLength: '都道府県の入力内容に不備があります。'
      },
      addr1: {
        required: '市区町村は入力必須項目です。',
        maxLength: '市区町村は100文字以内で入力してください。'
      },
      addr2: {
        required: '番地は入力必須項目です。',
        maxLength: '番地は100文字以内で入力してください。'
      },
      addr3: {
        maxLength: 'ビル名は100文字以内で入力してください。'
      },
      busho: {
        required: '部署は入力必須項目です。',
        maxLength: '部署は100文字以内で入力してください。'
      },
      telNo: {
        required: '電話番号は入力必須項目です。',
        maxLength: '電話番号は20文字以内で入力してください。'
      },
      remarks: {
        maxLength: '備考は20000文字以内で入力してください。'
      },
      services: {
        required: '利用希望サービスは入力必須項目です。'
      },
      freelance: {
        recommendationCompanyName: {
          required: '推薦社名は入力必須項目です。',
          maxLength: '推薦社名は100文字以内で入力してください。'
        },
        recommendationMediaName: {
          required: '推薦媒体名は入力必須項目です。',
          maxLength: '推薦媒体名は100文字以内で入力してください。'
        },
        mediaContents: {
          required: '媒体内容は入力必須項目です。',
          maxLength: '媒体内容は20000文字以内で入力してください。'
        },
        mediaIssueDetail: {
          required: '媒体発行詳細は入力必須項目です。',
          maxLength: '媒体発行詳細は20000文字以内で入力してください。'
        },
        recommendationResponsibleName: {
          required: '推薦責任者名は入力必須項目です。',
          maxLength: '推薦責任者名は100文字以内で入力してください。'
        },
        recommendationResponsibleMailAddress: {
          required: '推薦責任者メールアドレスは入力必須項目です。',
          maxLength: '推薦責任者メールアドレスは100文字以内で入力してください。',
          invalid: '推薦責任者メールアドレスの書式に誤りがあります。'
        },
        recommendationReason: {
          required: '推薦理由は入力必須項目です。',
          maxLength: '推薦理由は20000文字以内で入力してください。'
        },
        trackRecord: {
          required: '取材活動実績は入力必須項目です。',
          maxLength: '取材活動実績は20000文字以内で入力してください。'
        },
        uploadFiles: {
          illegalExtension: '対応していないファイル形式です。',
          sizeOver: 'ファイルサイズが50MBを超えています。',
          nameMaxLength: 'ファイル名が長すぎます。100文字以内に変更してください。',
          invalid: '取材活動実績の添付ファイルが不正です。'
        }
      },
      localMedia: {
        mediaIssueDetail: {
          required: '媒体発行詳細は入力必須項目です。',
          maxLength: '媒体発行詳細は20000文字以内で入力してください。'
        },
        mediaCoverageArea: {
          required: '媒体カバーエリアは入力必須項目です。',
          maxLength: '媒体カバーエリアは20000文字以内で入力してください。'
        },
        groupResponsibleName: {
          required: 'グループ責任者名は入力必須項目です。',
          maxLength: 'グループ責任者名は100文字以内で入力してください。'
        },
        userName: {
          required: '利用者名は入力必須項目です。',
          maxLength: '利用者名は20000文字以内で入力してください。'
        },
        localMediaManagementClub: {
          required: 'ローカル媒体管理クラブは入力必須項目です。'
        },
        other: {
          maxLength: 'その他は20000文字以内で入力してください。'
        }
      }
    },
    select: {
      other: 'その他'
    },
    button: {
      entry: '申請する',
      back: '戻る',
      searchCompany: '会社名から検索',
      fileAttachment: 'ファイル添付'
    },
    desc: {
      text1: 'は入力必須項目です。',
      acceptTermsOfUse1: 'アカウント申請のため',
      acceptTermsOfUse2: 'に同意します。',
      openTermsOfUse: '利用規約',
      serviceText: '・アカウント利用開始後にサービス利用審査が必要となる場合があります。',
      fileExt: '※対応ファイル形式： gif, jpg, jpeg, png, docx, pdf, pptx, txt, xlsx, zip',
      fileSize: '※最大ファイルサイズ： 50MB',
      id: '※フリーランス以外の方は、フリーメールでの登録はできません。'
    }
  },
  en: {
    title: {
      account: 'Register Account',
      freelance: 'Application as freelance',
      localMedia: 'Application as local media'
    },
    label: {
      id: 'ID',
      name: 'Name',
      group: 'Group',
      company: 'Company/Organization',
      branch: 'Branch',
      postNo: 'Postal code',
      prefCd: 'Prefecture',
      addr1: 'City',
      addr2: 'Street house number',
      addr3: 'Building Name',
      busho: 'Department',
      telNo: 'Phone number',
      remarks: 'Remarks',
      services: 'Services requested',
      recommendationCompanyName: 'Name of the company recommending you',
      recommendationMediaName: 'Name of media recommending you',
      mediaContents: 'Media category',
      mediaIssueDetail: 'Media details',
      recommendationResponsibleName: 'Name of person in charge',
      recommendationResponsibleMailAddress: 'E-mail address of person in charge',
      recommendationReason: 'Grounds for recommendation',
      trackRecord: 'Press Coverage Achievements',
      mediaCoverageArea: 'Media Coverage Area',
      groupResponsibleName: 'Name of person in charge for the group',
      userName: 'Names of users',
      localMediaManagementClub: 'Club recommending local media',
      other: 'Others'
    },
    ph: {
      id: 'Enter your email address',
      name: 'Enter your name',
      groupSmall: 'Select',
      companyId: 'Select',
      companyName: 'Enter your ##COMPANY_LABEL## name if you select "Other".',
      companyNameKana: '',
      branch: 'Select if you have a ##BRANCH_LABEL##.',
      branchName: 'Enter your ##BRANCH_LABEL## name if you select "Other".',
      branchNameKana: '',
      postNo: 'Enter postal code',
      prefCd: 'Select',
      addr1: 'Enter city',
      addr2: 'Enter street house number',
      addr3: 'Enter building name',
      busho: 'Enter department',
      telNo: 'Enter phone number',
      remarks: 'Enter remarks.\n* I you are a journalist or photographer, please indicate whether you are a "Pen Journalist" or "Photographer".\n* If there is anything else you would like to tell us, please fill in this form.',
      recommendationCompanyName: 'Please enter the name of the company.',
      recommendationMediaName: 'Please enter the name of media.',
      mediaContents: 'Please enter media category.',
      mediaIssueDetail: 'Please indicate the number of circulation and frequency of publication.',
      recommendationResponsibleName: 'Please enter the name of person in charge.',
      recommendationResponsibleMailAddress: 'Please enter the email address of person in charge.',
      recommendationReason: 'Please enter grounds for recommendation.',
      trackRecord: 'Please describe your past coverage activities (exposure media, URL, etc.).',
      mediaCoverageArea: 'Please indicate media coverage area.\n*For web media, please provide your company\'s location.',
      groupResponsibleName: 'Please enter the name of the person in charge for the group.',
      userName: 'Please fill in the names of all users.',
      localMediaManagementClub: 'Select',
      other: 'Please fill in additional information if any.'
    },
    error: {
      id: {
        required: 'ID is required.',
        maxLength: 'ID must be within 100 characters.',
        invalid: 'There is an error in the format (ID).'
      },
      name: {
        required: 'Name is required.',
        maxLength: 'Name must be within 50 characters.'
      },
      groupLargeId: {
        required: 'Category is required.',
        invalid: 'Incomplete (Category)'
      },
      groupSmallId: {
        required: 'Subcategory is required.',
        invalid: 'Incomplete (Subcategory)'
      },
      companyId: {
        required: '##COMPANY_LABEL## is required.',
        invalid: 'Incomplete (##COMPANY_LABEL##)'
      },
      companyName: {
        required: 'Enter your ##COMPANY_LABEL## name if you select "Other".',
        maxLength: '##COMPANY_LABEL## name must be within 100 characters.'
      },
      branchId: {
        required: '##BRANCH_LABEL## is required.',
        invalid: 'Incomplete (##BRANCH_LABEL##)'
      },
      branchName: {
        required: 'Enter your ##BRANCH_LABEL## name if you select "Other".',
        maxLength: '##BRANCH_LABEL## name must be within 100 characters.'
      },
      postNo: {
        required: 'Postal code is required.',
        maxLength: 'Postal code must be within 20 characters.'
      },
      prefCd: {
        required: 'Prefecture is required.',
        maxLength: 'Incomplete (Prefecture)'
      },
      addr1: {
        required: 'City is required.',
        maxLength: 'City must be within 100 characters.'
      },
      addr2: {
        required: 'Street house number is required.',
        maxLength: 'Street house number must be within 100 characters.'
      },
      addr3: {
        maxLength: 'Building Name must be within 100 characters.'
      },
      busho: {
        required: 'Department is required.',
        maxLength: 'Department must be within 100 characters.'
      },
      telNo: {
        required: 'Phone number is required.',
        maxLength: 'Phone number must be within 20 characters.'
      },
      remarks: {
        maxLength: 'Remarks must be within 20000 characters.'
      },
      services: {
        required: 'Services requested is required.'
      },
      freelance: {
        recommendationCompanyName: {
          required: 'Name of the company recommending you is required.',
          maxLength: 'Name of the company recommending you must be within 100 characters.'
        },
        recommendationMediaName: {
          required: 'Name of media recommending you is required.',
          maxLength: 'Name of media recommending you must be within 100 characters.'
        },
        mediaContents: {
          required: 'Media category is required.',
          maxLength: 'Media category must be within 20000 characters.'
        },
        mediaIssueDetail: {
          required: 'Media details is required.',
          maxLength: 'Media details must be within 20000 characters.'
        },
        recommendationResponsibleName: {
          required: 'Name of person in charge is required.',
          maxLength: 'Name of person in charge must be within 100 characters.'
        },
        recommendationResponsibleMailAddress: {
          required: 'E-mail address of person in charge is required.',
          maxLength: 'E-mail address of person in charge must be within 100 characters.',
          invalid: 'There is an error in the format (E-mail address of person in charge).'
        },
        recommendationReason: {
          required: 'Grounds for recommendation is required.',
          maxLength: 'Grounds for recommendation must be within 20000 characters.'
        },
        trackRecord: {
          required: 'Press Coverage Achievements is required.',
          maxLength: 'Press Coverage Achievements must be within 20000 characters.'
        },
        uploadFiles: {
          illegalExtension: 'File format not supported.',
          sizeOver: 'File size exceeds 50 MB.',
          nameMaxLength: 'File name is too long, please change to 100 characters or less.',
          invalid: 'The attachment of the results of the Press Coverage Achievements is incorrect.'
        }
      },
      localMedia: {
        mediaIssueDetail: {
          required: 'Media details is required.',
          maxLength: 'Media details must be within 20000 characters.'
        },
        mediaCoverageArea: {
          required: 'Media Coverage Area is required.',
          maxLength: 'Media Coverage Area must be within 20000 characters.'
        },
        groupResponsibleName: {
          required: 'Name of person in charge for the group is required.',
          maxLength: 'Name of person in charge for the group must be within 100 characters.'
        },
        userName: {
          required: 'Names of users is required.',
          maxLength: 'Names of users must be within 20000 characters.'
        },
        localMediaManagementClub: {
          required: 'Club recommending local media is required.'
        },
        other: {
          maxLength: 'Others must be within 20000 characters.'
        }
      }
    },
    select: {
      other: 'Other'
    },
    button: {
      entry: 'Apply',
      back: 'Back',
      searchCompany: 'Search by Company',
      fileAttachment: 'File attachement'
    },
    desc: {
      text1: ' is required.',
      acceptTermsOfUse1: 'I agree to the ',
      acceptTermsOfUse2: '',
      openTermsOfUse: 'Terms of Use',
      serviceText: '- You may be required to go through a service usage review after you start using your account.',
      fileExt: '*Supported file formats : gif, jpg, jpeg, png, docx, pdf, pptx, txt, xlsx, zip',
      fileSize: '*Maximum file size : 50MB',
      id: '*Non-freelances are not allowed to register with a free email.'
    }
  }
}
